import { Box } from "@mui/material";

import Onboarding, { OnboardingType } from "../../../components/onboarding";
// styles
import styles from "./styles.module.css";

const Verification = () => {
  return (
    <div className={styles.card}>
      <Onboarding type={OnboardingType.SMALL} />
    </div>
  );
};

export default Verification;
